import { render, staticRenderFns } from "./tagItem.vue?vue&type=template&id=f2774e44&scoped=true"
import script from "./tagItem.vue?vue&type=script&lang=js"
export * from "./tagItem.vue?vue&type=script&lang=js"
import style0 from "./tagItem.vue?vue&type=style&index=0&id=f2774e44&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2774e44",
  null
  
)

export default component.exports